import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { SeoTextInsertComponent } from '@commons/seo-page//seo-text-insert/seo-text-insert.component';
import { SeoHeroComponent } from '@commons/seo-page/seo-hero/seo-hero.component';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';

export interface SeoHeroConfig {
  title: string;
  content: string;
  illustrationSrc: string;
}

@Component({
  selector: 'app-seo-page',
  templateUrl: './seo-page.component.html',
  styleUrls: ['./seo-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeoPageComponent {
  @Input() seoHeroConfig!: SeoHeroConfig;
}

@NgModule({
  imports: [ImaginarySrcModule, CommonModule],
  declarations: [SeoPageComponent, SeoHeroComponent, SeoTextInsertComponent],
  exports: [SeoPageComponent, SeoTextInsertComponent],
})
export class SeoPageModule {}
